import Base from './Base';

export default class AircallNumber extends Base {
    get full_name() {
        if (!this.users.length) return '';

        return this.users[0].full_name;
    }

    get type() {
        if (this.active) {
            return 'success';
        }

        return 'processing';
    }

    get status() {
        if (this.assigned) {
            return 'Active';
        }

        if (this.active) {
            return 'Enabled';
        }

        return 'Pending';
    }

    get tooltipValue() {
        if (!this.active) {
            return `Your number isn't ready. <br/>Learn more <a href="https://help.salesmessage.com/en/articles/4808864-aircall-numbers-not-ready-to-be-assigned" target="_blank">here</a>.`;
        }

        return '';
    }
}
